import { environment } from '@environments/environment';
import { Document } from '@app/generated/graphql';

export abstract class ServerSideFileHelper {
  static fullUrl(file: Document) {
    if (!file || !file.url) {
      return null;
    }
    return `${environment.apiBaseUrl}${file.url}`;
  }
}
